module.exports = __webpack_public_path__ + "static/media/PechangaLogo.f2affc63.svg";